import debounce from 'lodash/debounce';
import dispatchCustomEvent from '../events/dispatchCustomEvent';
/**
  * CourseListSearch class to manage interaction with the search component of the course list UI
  *
  * @param {DOM element} target
  */
export default class CourseListSearch {
  constructor(target) {
    if (!target) { return; }

    this.target = target;
    this.input = target.querySelector('input[type="search"]');
    this.form = target.querySelector('form');
    this._setupEventHandler();
  }

  _search() {
    const text = this.input.value;
    dispatchCustomEvent(this.input, 'search', { text });
  }

  _setupEventHandler() {
    const handleOnce = debounce(() => this._search(), 350, { trailing: true });
    this.input.addEventListener('input', handleOnce);
    this.form.addEventListener('submit', (e) => { e.preventDefault(); });
    this.form.addEventListener('reset', () => {
      this.input.value = '';
      this._search();
    });
  }

  setSearchValue(query) {
    if (!this.input) { return; }

    this.input.value = query;
  }
}
